import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs/Subscription';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DateService, ConfirmationService, ModalService, PatientService, UserService, ValidateService} from '../../services';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-pop-up-document',
  templateUrl: './pop-up-document.component.html',
  styleUrls: ['./pop-up-document.component.scss']
})
export class PopUpDocumentComponent implements OnInit  {

  public paginatedDocuments = [];
  private subscription: Subscription;
  public documents;
  public errors;
  @Input() imei;

  public next: number = 0;
  public isLoading = false;
  public acceptRules = false;
  public isExtra = false;
  public isChecked: boolean = false;

  constructor(
    private fb: FormBuilder,
    private translateService: TranslateService,
    private validateService: ValidateService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: ModalService,
    private confirmation: ConfirmationService,
    private dateService: DateService,
    private userService: UserService,
    private patientService: PatientService,
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
    if (this.imei) {
      this.loadDocuments();
      return;
    }

    this.subscription = this.route.params.subscribe(params => {
      if (params['imei']) {
        this.imei = params['imei'];
        this.loadDocuments();
      }
    });
  }

  private loadDocuments() {
    this.isLoading = true;
    this.patientService.getDocuments(this.imei, true).subscribe(data => {
      this.isLoading = false;
      if (data) {
        this.documents = data.documents;
        this.paginatedDocuments = this.documents.slice(0, 10);

        if (data.termsAccepted) {
          this.isExtra = true;
          this.acceptRules = true;
        } else {
          this.isExtra = false;
        }
      }
    });
  }

  changeDocument(newValue){
    this.patientService.uploadDocumentToDocumentation(newValue)
      .subscribe(
        () => {

          let messageToModal = '<h3 style="font-size: 1.7rem">' + this.translateService.instant('RODO.MODAL-TITLE') + '! </h3> <br/>' + this.translateService.instant('RODO.MODAL')

          this.confirmation.showHtml(messageToModal, 'EVENTS.SHARED.COMPONENTS.POP-UP-DOCUMENT.POPUP.CHANGE-DOCUMENT');
          this.loadDocuments();

        },
        err => {
          this.errors = err;

          if(err.errors == 'BUSY') {
            this.modalService.open(this.translateService.instant('DOCUMENTS.BUSY-FILE'), undefined, undefined, 'EVENTS.SHARED.COMPONENTS.POP-UP-DOCUMENT.POPUP.DOCUMENTS-BUSY-FILE')

          } else if(err.errors == 'EXIST') {
            this.modalService.open(this.translateService.instant('DOCUMENTS.EXIST'), undefined, undefined, 'EVENTS.SHARED.COMPONENTS.POP-UP-DOCUMENT.POPUP.DOCUMENTS-EXIST')

          } else{
            this.confirmation.showErrorToast('DOCUMENTS.COULDNT-ADD');

          }
        });

  }

  onCheckboxChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    let data = {
      imei: this.imei,
      termsAcceptedStatus: isChecked
    };
    this.patientService.saveTermsAccepted(data).subscribe(() => {
    }, () => {
    });
  }

  public paginateDocuments(data) {
    this.paginatedDocuments = data;
  }

  public acceptDocuments(){
    this.patientService.changeStatus(5).subscribe(() => {
      this.router.navigateByUrl("/users/user/" + this.imei);

    });
  }

  goNext() {

    if (!this.isChecked) {
      this.modalService.open(this.translateService.instant('BACKEND.MODAL-ACCEPT-RULES'), undefined, undefined, 'EVENTS.SHARED.COMPONENTS.POP-UP-DOCUMENT.POPUP.BACKEND-MODAL-ACCEPT-RULES')
      return false;
    }
    this.next += 1;
  }

  goPrevious() {
    this.next -= 1;
  }

  goToLink() {
    window.open("https://teleopiekomat.pl/dokumenty/7_Oświadczenie_pacjenta.pdf", '_blank');
  }

  onGetStarted() {
    this.router.navigateByUrl('/users/user/' + this.imei);
  }

  purgeAuth() {
    this.userService.purgeAuth();
    this.router.navigateByUrl('/auth/login');
    setTimeout(() => {
      window.location.reload(false);
    }, 100);
  }

}
